import type { AppMode } from '../types';

/**
 * Converts an AppMode and params to a URL path
 */
export function modeToUrl(mode: AppMode, params?: Record<string, any>): string {
  const modeMap: Record<string, string | ((params?: Record<string, any>) => string)> = {
    'dashboard': '/',
    'guides': '/guides',
    'help-centers': '/help-centers',
    'portal-settings': '/settings/shared-guides',
    'add-guide': '/guides/new',
    'edit-guide': (params) => params?.id ? `/guides/${params.id}/edit` : '/guides',
    // Articles are managed as help center items; legacy 'articles' / 'edit-article'
    // modes fall through to '/'.
  };

  const urlOrFn = modeMap[mode];
  
  if (typeof urlOrFn === 'function') {
    return urlOrFn(params);
  }
  
  return urlOrFn || '/';
}

